import type { IconProps } from '../types/IconProps.ts';
export const Info: IconProps = {
    name: 'Info',
    children: [
        `<circle cx="12" cy="12" r="10" />`,
        `<path d="M12 12v4" />`,
        `<circle cx="12" cy="8" r=".5" />`,
    ]
};